export function getBeforeIconProps({ beforeIconProps, height }) {
  return beforeIconProps
    ? {
        beforeIconProps: {
          ...beforeIconProps,
          height: beforeIconProps.height || height,
        },
      }
    : null
}

export function getAfterIconProps({ afterIconProps, height }) {
  return afterIconProps
    ? {
        afterIconProps: {
          ...afterIconProps,
          height: afterIconProps.height || height,
        },
      }
    : null
}
